import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';
import ReactSelect from 'react-select';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants';
import ERROR_MESSAGE from '../../constants/errorMsgs';
import UI from '../../constants/ui';
import { createOptions } from '../../helpers/createOption';

const customStyles = {
  placeholder: (provided) => ({
    ...provided,
    color: '#bcbcbc', // TODO will check if bette option
  }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  control: (provided) => ({
    ...provided,
    minHeight: 39,
  }),
};

function Select({
  name,
  options,
  control,
  onChange: updatedOnChange,
  isRequired,
  isClearableHidden,
  disabled,
  errorlabel,
  ...rest
}) {
  const updatedOptions = createOptions(options);

  return (
    <div id={name} data-errorlabel={errorlabel}>
      <Controller
        name={name}
        control={control}
        rules={
          isRequired
            ? {
                required: ERROR_MESSAGE.REQ_ERROR_MSG,
              }
            : {
                required: false,
              }
        }
        render={({ field: { value, onChange, onBlur } }) => (
          <ReactSelect
            styles={customStyles}
            {...rest}
            isClearable={!isClearableHidden}
            menuPortalTarget={document.body}
            options={updatedOptions}
            menuPosition="fixed"
            placeholder={UI.SELECT_OPTION}
            onChange={(option) => {
              const updatedValue = option?.value ? option.value : null;
              onChange(updatedValue);
              updatedOnChange?.(updatedValue);
            }}
            onBlur={onBlur}
            value={
              updatedOptions.find((option) => value === option?.value) || null
            }
            defaultValue={updatedOptions.find(
              (option) => value === option?.value
            )}
            isDisabled={disabled}
          />
        )}
      />
    </div>
  );
}

Select.propTypes = {
  name: PropTypes.string,
  options: PropTypes.array,
  control: PropTypes.object,
  onChange: PropTypes.func,
  isRequired: PropTypes.bool,
  isClearableHidden: PropTypes.bool,
  disabled: PropTypes.bool,
  errorlabel: PropTypes.string,
};

Select.defaultProps = {
  name: undefined,
  options: EMPTY_ARRAY,
  control: EMPTY_OBJECT,
  onChange: noop,
  isRequired: false,
  isClearableHidden: false,
  disabled: false,
  errorlabel: undefined,
};

export default Select;
